import ChatContext from "@/shared/models/ChatContext";
import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { ChatShort } from "../../../shared/models/Chat";
import {
  EventName,
  EventParameter,
  EventTitle,
  sendEvent,
} from "../../../shared/utils/UsageAnalytics";

export const useRunPlaybook = () => {
  const { data: chat, call } = useApiPrivateRequest<ChatShort>(
    (response) => new ChatShort(response),
  );
  const runPlaybook = async (playbookId: string, context: ChatContext) => {
    const data = context.extractChatCreateData();
    const body = {
      companyIds: data.companyIds,
      filingIds: data.filingIds,
      transcriptIds: data.transcriptIds,
      userDocumentIds: data.userDocumentIds,
      useInternet: data.includeWeb,
      llmName: data.selectedLlmName,
    };

    await call(`/playbooks/${playbookId}/run`, "POST", undefined, body);

    sendEvent(EventName.ChatCreated, {
      [EventParameter.ChatMode]: EventTitle.ChatModeCompanyDocsV2,
    });
  };

  return { chat, runPlaybook };
};
